import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.ac{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.ai{overflow-y:hidden;}.ssr-plugin'
import '.dc{padding:1rem 1.5rem;}.ssr-plugin'
import '.cl{background:var(--shades-white);}.ssr-plugin'
import '.a0{justify-content:space-between;}.ssr-plugin'
import '.g0{padding:2rem 1.5rem;}.ssr-plugin'
import '.g1{max-height:80vh;}.ssr-plugin'
import '.dk{justify-content:flex-end;}.ssr-plugin'
import '.a6{gap:1rem;}.ssr-plugin'
import { styled } from 'inlines'
import { ReactNode } from 'react'
import { Button } from '@app/components/core/button/Button'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import useMediaQuery from '@app/util/useMediaQuery'

export type ModalProps = {
  children: ReactNode
  isOpen: boolean
  title?: string
  loading?: boolean
  renderContainer?: HTMLElement
  onClose: () => void
  onConfirm?: () => void
}

export const Modal = ({
  children,
  isOpen,
  loading,
  title,
  renderContainer,
  onClose,
  onConfirm,
}: ModalProps) => {
  // Always call hooks first
  const translations = useTranslations().app.common
  const isMobile = useMediaQuery()
  // Early return after hooks
  if (!isOpen) {
    return null
  }
  const content = (
    <div className="a b ab ac ad ae ai"
      style={{
        maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',
      }}
    >
      <div className="a dc cl a0"
      >
        <Title.H5>{title ?? translations.attention}</Title.H5>
        <CloseButton onClick={onClose} size="small" />
      </div>
      <div className="a b g0 cl g1"
      >
        {children}
      </div>
      <div className="a dc cl dk a6"
      >
        <Button
          label={translations.back}
          onClick={onClose}
          variant="secondary"
        />
        {onConfirm && (
          <Button
            label={translations.continue}
            onClick={onConfirm}
            disabled={loading}
          />
        )}
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer}>{content}</ModalWrapper>
  )
}
